/**
 * Small imperative helper for the global auth-gate.
 *
 * Usage in any component (no hook needed):
 *
 *   import { requireAuth, getAuthUser } from "../lib/authGate";
 *
 *   function handleClick() {
 *     if (!requireAuth("basket")) return;        // shows modal, stops
 *     // ...proceed normally
 *   }
 *
 * `requireAuth(feature)` reads the JWT from localStorage (same key
 * `tanakh_token` that AuthContext uses). If present, returns true and
 * does nothing. If absent, dispatches a "torahya:auth-required" event
 * with the feature key — picked up by <GlobalAuthGate /> at the App
 * root, which shows the Hebrew sign-up modal — and returns false.
 *
 * We deliberately don't depend on React context here so this can be
 * called from event handlers, async flows, axios interceptors, etc.
 */
export function isAuthed() {
  try {
    return !!window.localStorage.getItem("tanakh_token");
  } catch {
    return false;
  }
}

export function requireAuth(feature = "default") {
  if (isAuthed()) return true;
  try {
    window.dispatchEvent(
      new CustomEvent("torahya:auth-required", { detail: { feature } })
    );
  } catch {
    /* very old browsers — ignore */
  }
  return false;
}
